import './DailyPop.css'

import React, { useEffect, useMemo, useState } from 'react'
import DatePicker from 'react-datepicker'
import { formatDate } from '@/common/time'
import { UserDeviceHistoriesData } from '@/pages/communal/statistics/requests/histories'

import { MapRow } from '@/components/Map/HitMap'
import { MachineBucket, MachineHistoryChart } from '../../bucketschart/MachineHistoryChart'
import { useAppContext } from '@/context/app'
import { MachineName } from '@/components/machine'
import { Machine } from '@/services/model/machine'
import { MapRowMachine } from '../../../machinestatistic/components/Map/Response'

interface Response {
  buckets: MachineBucket[]
}

export const DailyPopBody = ({
  machine, day, onClose
}: {
  machine: MapRowMachine
  day: Date
  onClose: () => void
}) => {
  // const navigate = useNavigate()
  // const [selectedMachine, setSelectedMachine] = useState<UserDeviceHistoriesMachine>()
  // const [navData, setNavData] = useState<HitMapNavData>({
  //   range: {
  //     from: row.startAt ? new Date(row.startAt) : new Date(),
  //     to: row.endAt ? new Date(row.endAt) : new Date()
  //   },
  //   hitLvl: 'all',
  //   machinePoint: row.machineId,
  //   username: '',
  //   hitRange: hitsMap.all
  // })
  // const [rows, setRows] = useState<MapRow[] | undefined>(undefined)
  const { services, translates } = useAppContext()
  const [currentDay, setCurrentDay] = useState(day)
  const [data, setData] = useState<Response>()
  // @ts-ignore: Unreachable code error
  const ReactDatePicker = DatePicker.default ?? DatePicker;
  /* tslint:enable */

  useEffect(() => {
    setData(undefined)
    services.session.fetchWithToken(`/api/communal/machines/byid/${machine.id}/statistics/daily?machine=${machine.id}&date=${currentDay.toISOString()}`).then(async (r) => {
      if (r.status !== 200) {
        const erros = await r.json()
        console.error(erros)
        return Promise.reject<MapRow[]>()
      }
      const resp: Response = await r.json()
      setData(resp)
    })
  }, [currentDay])


  if (!translates || !data) {
    return <div className='spinner'></div>
  }

  return <div className='communal-statistics-machine-daily-pop'>
    <h2><MachineName row={machine} /></h2>

    <ReactDatePicker
      selected={currentDay}
      onChange={(date: Date | null) => {
        if (date) {
          setCurrentDay(date)
        }
      }}
      maxDate={new Date()}
      dateFormat='yyyy-MM-dd'
      customInput={<h3 style={{
        cursor: 'pointer'
      }}>{formatDate(currentDay)}</h3>}
      withPortal
    />

    <div style={{ width: '100%' }}>
      <MachineHistoryChart buckets={data.buckets} />
    </div>
  </div>
}

